import {curry} from 'ramda';

import humanizeRange from '@pluto/humanize-moment-range';
import {DateRangeState} from '@pluto/daterange-picker/DateRangeTypes';
import {FilterHandlers} from '../../QCWorkflow/QCManager/QCManagerTypes';

export const applySetDates = (sort: string, setDueDates: (value: DateRangeState) => void, setFinishDates: (value: DateRangeState) => void | undefined, setStartDates: (value: DateRangeState) => void | undefined, dates: DateRangeState) => {
    switch(sort) {
    case 'startDate':
        setStartDates(dates);
        break;
    case 'finishDate':
        setFinishDates(dates);
        break;
    
    default:
        setDueDates(dates);
        break;
    }
};

export const getDateRange = (sort: string, dates: [string, string]) => {
    const [dateStart, dateEnd] = dates;
    
    switch(sort) {
    case 'finishDate':
        return {
            finishDateStart: dateStart,
            finishDateEnd: dateEnd,
        };
    
    case 'startDate':
        return {
            startDateStart: dateStart,
            startDateEnd: dateEnd,
        };
    
    default:
        return {
            dateStart,
            dateEnd,
        };
    }
};

export const handleDateRangeChange = curry((containerParams: FilterHandlers, sort: string, dates: DateRangeState) => {
    const {
        setPage,
        setQuery,
        history,
        setQCJobs,
        rowsPerPage,
        filters,
        title,
        sortOrder,
        finishDates,
        startDates,
        setStartDates,
        dueDates,
        setDueDates,
        setFinishDates,
        route,
    } = containerParams;
    
    const [finishDateStart, finishDateEnd] = humanizeRange(finishDates);
    const [startDateStart, startDateEnd] = humanizeRange(startDates);
    const [dateStart, dateEnd] = humanizeRange(dueDates);
    const humanizeDate = humanizeRange(dates);
    const dateRange = getDateRange(sort, humanizeDate);
    
    const query = {
        ...filters,
        startDateStart,
        startDateEnd,
        finishDateStart,
        finishDateEnd,
        dateStart,
        dateEnd,
        ...dateRange,
        offset: 0,
        title,
        limit: rowsPerPage,
        sortOrder,
    };
    
    setPage(0);
    setQuery(history, route, query);
    applySetDates(
        sort,
        setDueDates,
        setFinishDates,
setStartDates as any,
dates,
    );
    setQCJobs(query);
});
